import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../styles/Footer.css"

const Footer = () => {
    const [activeSection, setActiveSection] = useState("home");
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    // Scroll event handler to change navbar background
    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 50;
            setScrolled(isScrolled);
        };

        // Add scroll event listener
        window.addEventListener("scroll", handleScroll);

        // Set initial state
        handleScroll();

        // Cleanup
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    // Intersection Observer only for home page sections
    useEffect(() => {
        if (location.pathname !== "/") return;

        const sections = ["home", "activities", "bookings"];
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            { threshold: 0.6, rootMargin: "-20% 0px -70% 0px" }
        );

        sections.forEach((id) => {
            const el = document.getElementById(id);
            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, [location.pathname]);

    // Update active section based on current route
    useEffect(() => {
        if (location.pathname === "/about") {
            setActiveSection("about");
        } else if (location.pathname === "/contact") {
            setActiveSection("contact");
        }
    }, [location.pathname]);

    return (
        <div className='footermain' data-aos="fade-up">
            <div className='footer1' data-aos="fade-up">
                <div className='footeralign'>
                    <h2 className='footh2'>Green Play Turf</h2>
                    <p className='footp'>Your premium destination for
                        multi-purpose turf bookings.
                        Experience the best in cricket,
                        football, and event facilities.</p>
                    <div className='iconalign'>
                        <div className='footericon'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 440 146.7 540.8 258.2 568.5L258.2 398.2L205.4 398.2L205.4 320L258.2 320L258.2 286.3C258.2 199.2 297.6 158.8 383.2 158.8C399.4 158.8 427.4 162 438.9 165.2L438.9 236C432.9 235.4 422.4 235 409.3 235C367.3 235 351.1 250.9 351.1 292.2L351.1 320L434.7 320L420.3 398.2L351 398.2L351 574.1C477.8 558.8 576 450.9 576 320z" /></svg></div>
                        <div className='footericon'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M320.3 205C256.8 204.8 205.2 256.2 205 319.7C204.8 383.2 256.2 434.8 319.7 435C383.2 435.2 434.8 383.8 435 320.3C435.2 256.8 383.8 205.2 320.3 205zM319.7 245.4C360.9 245.2 394.4 278.5 394.6 319.7C394.8 360.9 361.5 394.4 320.3 394.6C279.1 394.8 245.6 361.5 245.4 320.3C245.2 279.1 278.5 245.6 319.7 245.4zM413.1 200.3C413.1 185.5 425.1 173.5 439.9 173.5C454.7 173.5 466.7 185.5 466.7 200.3C466.7 215.1 454.7 227.1 439.9 227.1C425.1 227.1 413.1 215.1 413.1 200.3zM542.8 227.5C541.1 191.6 532.9 159.8 506.6 133.6C480.4 107.4 448.6 99.2 412.7 97.4C375.7 95.3 264.8 95.3 227.8 97.4C192 99.1 160.2 107.3 133.9 133.5C107.6 159.7 99.5 191.5 97.7 227.4C95.6 264.4 95.6 375.3 97.7 412.3C99.4 448.2 107.6 480 133.9 506.2C160.2 532.4 191.9 540.6 227.8 542.4C264.8 544.5 375.7 544.5 412.7 542.4C448.6 540.7 480.4 532.5 506.6 506.2C532.8 480 541 448.2 542.8 412.3C544.9 375.3 544.9 264.5 542.8 227.5zM495 452C487.2 471.6 472.1 486.7 452.4 494.6C422.9 506.3 352.9 503.6 320.3 503.6C287.7 503.6 217.6 506.2 188.2 494.6C168.6 486.8 153.5 471.7 145.6 452C133.9 422.5 136.6 352.5 136.6 319.9C136.6 287.3 134 217.2 145.6 187.8C153.4 168.2 168.5 153.1 188.2 145.2C217.7 133.5 287.7 136.2 320.3 136.2C352.9 136.2 423 133.6 452.4 145.2C472 153 487.1 168.1 495 187.8C506.7 217.3 504 287.3 504 319.9C504 352.5 506.7 422.6 495 452z" /></svg></div>
                        <div className='footericon'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M453.2 112L523.8 112L369.6 288.2L551 528L409 528L297.7 382.6L170.5 528L99.8 528L264.7 339.5L90.8 112L236.4 112L336.9 244.9L453.2 112zM428.4 485.8L467.5 485.8L215.1 152L173.1 152L428.4 485.8z" /></svg></div>
                    </div>
                </div>
                <div className='footeralign'>
                    <h2 className='footh2'>Quick Links</h2>
                    <p className='footp'> <a href="/"> Home &#8599;</a></p>
                    <p className='footp'> <a href="/about">About us &#8599;</a></p>
                    <p className='footp'> <a href="/contact"> Contact &#8599;</a></p>
                </div>
                {/* <div className='footeralign'>
                    <h2 className='footh2'>Sports</h2>
                    <p className='footp'>Cricket</p>
                    <p className='footp'>Football</p>
                    <p className='footp'>Corporate Events</p>
                    <p className='footp'>Tournaments</p>
                </div> */}
                <div className='footeralign'>
                    <h2 className='footh2'>Contact Us</h2>
                    <div className='footer11'>
                        <div className='footericon1'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M224.2 89C216.3 70.1 195.7 60.1 176.1 65.4L170.6 66.9C106 84.5 50.8 147.1 66.9 223.3C104 398.3 241.7 536 416.7 573.1C493 589.3 555.5 534 573.1 469.4L574.6 463.9C580 444.2 569.9 423.6 551.1 415.8L453.8 375.3C437.3 368.4 418.2 373.2 406.8 387.1L368.2 434.3C297.9 399.4 241.3 341 208.8 269.3L253 233.3C266.9 222 271.6 202.9 264.8 186.3L224.2 89z" /></svg></div>
                        <p className='futnam'>+91 9876543210</p>
                    </div>
                    <div className='footer11'>
                        <div className='footericon1'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M112 128C85.5 128 64 149.5 64 176C64 191.1 71.1 205.3 83.2 214.4L291.2 370.4C308.3 383.2 331.7 383.2 348.8 370.4L556.8 214.4C568.9 205.3 576 191.1 576 176C576 149.5 554.5 128 528 128L112 128zM64 260L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 260L377.6 408.8C343.5 434.4 296.5 434.4 262.4 408.8L64 260z" /></svg></div>
                        <p className='futnam'>info@greenplayturf.com</p>
                    </div>
                    <p className='footp'>123 Sports Complex, Green
                        Avenue,
                        Mumbai, Maharashtra 400001</p>
                </div>
            </div>
            <hr style={{ width: "85%" }} />
            <div className='footer2' data-aos="fade-up">
                <div><p className='footp'>© 2025 Green Play Turf. All rights reserved.</p></div>
                <div className='footer22'>
                    <p className='footp'>Privacy Policy</p>
                    <p className='footp'>Terms of Service</p>
                </div>
            </div>
        </div>
    )
}

export default Footer